import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid var(--ttg-green)',
  boxShadow: 24,
  p: 4,
};

interface CustomizedModalProp {
  open: boolean;
  clickHandler: () => void;
  secondaryClickHandler?: () => void;
  title?: string;
  description?: string;
  buttonText?: string;
  secondaryButtonText?: string;
}

const CustomizedModal: React.FC<CustomizedModalProp> = ({
  open,
  clickHandler,
  secondaryClickHandler,
  title,
  description,
  buttonText,
  secondaryButtonText,
}) => {
  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {title || 'You do not have a profile'}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {description || 'Creating a profile to stand out!'}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              marginTop: 3,
              marginBottom: 3,
            }}
          >
            {secondaryClickHandler && (
              <Button
                variant="outlined"
                onClick={secondaryClickHandler}
                sx={{
                  borderColor: 'var(--ttg-green)',
                  color: 'var(--ttg-green)',
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                }}
              >
                {secondaryButtonText || 'Cancel'}
              </Button>
            )}
            <Button
              variant="contained"
              sx={{
                backgroundColor: 'var(--ttg-green)',
                '&:hover': {
                  backgroundColor: 'var(--button-hover-green)',
                },
              }}
              onClick={clickHandler}
            >
              {buttonText || 'Create My Profile'}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default CustomizedModal;
